import { LOCALSTORAGE_KEYS } from "../constants/users";

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

/**
 * "Access as user" leaves mockUser in localStorage, and every request then
 * sends that user's shop as domain-hostname. Nobody is signed in on the login
 * page, so a leftover one only rebrands this shop as someone else's.
 * Localhost keeps it: dev auto-login runs on mockUser.
 * Returns true when one was removed.
 */
export function dropStaleImpersonation() {
  if (typeof window === "undefined") return false;
  if (LOCAL_HOSTS.has(window.location.hostname)) return false;
  try {
    if (!localStorage.getItem(LOCALSTORAGE_KEYS.mockUser)) return false;
    localStorage.removeItem(LOCALSTORAGE_KEYS.mockUser);
    return true;
  } catch {
    return false;
  }
}

if (
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/login")
) {
  dropStaleImpersonation();
}
